module.exports = __webpack_public_path__ + "cork.jpg?adbb48bca1c30dad8761b10e49e0ff03";